import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Municipio } from '../entities/municipios';
import { environment } from 'environments/environment';
import { Barrio } from '../entities/Barrio';
import { Edificio } from '../entities/edificio';
import { Comuna } from '../entities/comunas';
import { Direccion } from '../entities/direccion';
import { Grupo, Beneficiario, Titular } from '../entities/personajes';
import { Titulares, Grupos, Beneficiarios } from 'app/entities/contratos';

@Injectable({
    providedIn: 'root'
})
export class DireccionService {
    constructor(private _http: HttpClient) {}
    /** Devuelve un arreglo de los municipios que hay en la base de datos  */
    getCiudades(): Observable<Array<Municipio>>{
        return this._http.get<Array<Municipio>>(`${ environment.api}geo/ciudades/activas`);
    }
    /** Devuelve un arreglo de los barrios que pertenecen a una ciudad en la base de datos  */
    getBarriosOfACity(muncod): Observable<Array<Barrio>>{
        return this._http.get<Array<Barrio>>(`${environment.api}geo/ciudad/${muncod}/barrios`);
    }
    /** Devuelve un arreglo de los edificios que pertenecen a un barrio en la base de datos  */
    getEdificiosOfABarrio(idBarrio): Observable<Array<Edificio>>{
        return this._http.get<Array<Edificio>>(`${environment.api}geo/barrio/${idBarrio}/edificios`);
    }
    /** Devuelve un arreglo de las comunas que pertenecen a una ciudad en la base de datos  */
    getComunasDeUnaCiudad(codigoCiudad): Observable<Array<Comuna>>{
        return this._http.get<Array<Comuna>>(`${environment.api}geo/ciudad/${codigoCiudad}/comunas`);
    }
    /** Devuelve un arreglo de los barrios que pertenecen a una comuna en la base de datos  */
    getBarriosDeUnaComuna( comunaID ): Observable<Array<Barrio>>{
        return this._http.get<Array<Barrio>>(`${environment.api}geo/comuna/${comunaID}/barrios`)
    }
    /** Agrega un nuevo barrio  */
    newBarrio(formData){
        return this._http.post(`${environment.api}geo/barrio`,formData);
    }

    /** Crea un nuevo edificio */
    newEdificio(formData){
        return this._http.post(`${environment.api}geo/edificio`,formData);
    }
    /** Guarda la información de la dirección de una persona */
    saveDir(formData,beneficiario){
        return this._http.put(`${environment.api}geo/beneficiario/${beneficiario}/direccion`,formData);
    }
    /** Guarda la dirección de emergencia  */
    saveDirService(formData,csc){
        return this._http.put(`${environment.api}geo/servicio/${csc}/direccion`,formData);
    }
    /** Direccion de un beneficiario, para modal dirección */
    direccionDeUnBeneficiario(idBen):Observable<Direccion>{
        return this._http.get(`${environment.api}geo/beneficiario/${idBen}/direccion`) as Observable<Direccion>;
    }

    /** Actualiza el estado de la validación de el beneficiario */
    direccionValidada(idBen,usuario){
        return this._http.put(`${environment.api}geo/beneficiario/${idBen}/direccion/validar`,{usuario});
    }
    // Direccion de un servicio
    direccionDeUnServicio(csc):Observable<Direccion>{
        return this._http.get(`${environment.api}geo/service/${csc}/direccion`) as Observable<Direccion>;
    }
    //Información general de un grupo
    informacionGrupo(grupo):Observable<Grupo>{
        return this._http.get<Grupo>(`${environment.api}grupos-afi/${grupo}`);
    }

    // Paquete de grupo, titulares y beneficiarios por un radicado
    grupoBenTitContratos(grugru){
        return this._http.get<{grupo:Grupos,beneficiarios:Array<Beneficiarios>,titulares:Array<Titulares>}>(`${environment.api}grupos-afi/${grugru}/relacionados/contratos`);
    }
     // Paquete de grupo, titulares y beneficiarios por un radicado
    grupoBenTit(grugru){
        return this._http.get<{grupo:Grupo,beneficiarios:Array<Beneficiario>,titulares:Array<Titular>}>(`${environment.api}grupos-afi/${grugru}/relacionados`);
    }
    // Dirección de un titular
    direccionDeUnTitular(id):Observable<Direccion>{
        return this._http.get(`${environment}/geo/titular/${id}/direccion`) as Observable<Direccion>;
    }
}
